import propsflow from "propsflow"
import ReactRender from "src/engine/plugins/ReactRender"

/* This simple API allows you to painless start react application */
export const run = config => propsflow(...config, ReactRender)()
